import { render, staticRenderFns } from "./FormProductModelComponent.vue?vue&type=template&id=f90cbd48&scoped=true"
import script from "./FormProductModelComponent.vue?vue&type=script&lang=js"
export * from "./FormProductModelComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductModelComponent.vue?vue&type=style&index=0&id=f90cbd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90cbd48",
  null
  
)

export default component.exports